import { useSelector } from 'react-redux';

import type { AppState } from 'store/types';

export const getCurrentRegion = (state: AppState) => {
  return state?.website?.awsRegion;
};

export const useGetCurrentRegion = () => useSelector(getCurrentRegion);
